import PropTypes from 'prop-types';
import { RegionType } from './RegionType.enum';

export const RegionShape = PropTypes.shape({
	// 'north', 'west', or 'east' (for now, 'south' is not needed)
	region: PropTypes.oneOf(Object.keys(RegionType)),

	// dimensions
	width: PropTypes.number,
	height: PropTypes.number,

	// when 'resizable' is set to `true`
	minWidth: PropTypes.number,
	maxWidth: PropTypes.number,

	// allow resizing
	resizable: PropTypes.bool,

	// flag indicating if the panel ('west' or 'east' region) is collapsed
	isCollapsed: PropTypes.bool,

	// flag indicating if the panel is hidden
	isHidden: PropTypes.bool,
});
